/**
 * Step Component Names Enum not only for the activation steps
 * but also for the onboarding steps ZERO DEPENDENCIES
 *
 * This file contains only the enum, no component imports.
 * The actual component registry is in stepComponents.ts
 */

/**
 * Enum for step component names
 * Provides type-safe component references and better autocomplete
 */
export enum StepComponentName {
  // Pre-account steps
  MeetAccountableBanking = 'MeetAccountableBanking',
  PeppolBanking = 'PeppolBanking',
  AutomaticallyReserveTaxes = 'AutomaticallyReserveTaxes',
  FullTransparency = 'FullTransparency',
  OnboardingForm = 'OnboardingForm',
  FinanzamtDocUploader = 'FinanzamtDocUploader',
  ConfirmIdentity = 'ConfirmIdentity',

  // Post-account steps
  InitActivationStep = 'InitActivationStep',
  HowIsIntegratedStep = 'HowIsIntegratedStep',
  TaxesDescriptionStep = 'TaxesDescriptionStep',
  AccIbanOnInvoicesStep = 'AccIbanOnInvoicesStep',
  IssueCardStep = 'IssueCardStep',
  CardDesignStep = 'CardDesignStep',
  YourCardReadyStep = 'YourCardReadyStep',
  CardToWalletStep = 'CardToWalletStep',
  TopUpStep = 'TopUpStep',
  ReadyToGoStep = 'ReadyToGoStep',
}
